export default {
  clients: [],
  client: undefined,
  search: '',
};
